module.exports = __webpack_public_path__ + "static/media/illustrator.c986f0d4.svg";